var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('v-container',{staticClass:"py-4 py-lg-8"},[_c('div',{staticClass:"branch p-3"},[_c('h4',{staticClass:"text-h4 text-md-h4"},[_vm._v(" "+_vm._s(_vm.title))])]),_c('v-responsive',{staticClass:"mx-auto",attrs:{"max-width":"1200"}},[_c('div',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.subtitle))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }